<template>
  <div v-html="showContent" class="rich-txt-box">

  </div>
</template>

<script>
import {baseImgUrl} from "../api/config"
export default {
  name: "home",
  components: {

  },
  data() {
    return {
        showContent: "",
    };
  },
  watch: {

  },
  created() {
    this.getData();

  },
  methods: {
    async getData() {
      try {
          let data = {
            queryType: 5
          }
         let newApi = await this.$http.goAgreement(data);
        const res = newApi
        if (res.code == 200) {
            let mycontent;
            if (res.result.length && res.result.length > 0) {
              mycontent = res.result[0].articleContent;
            }
          mycontent = mycontent.replace(/\<img/gi, '<img class="rich-img"');
          this.showContent = mycontent;
        } else {
          this.$message(res.message);
        }
      } catch (e) {

        throw e
      }
    },
  },
};
</script>


<style scoped>
.rich-txt-box {
  /* padding: 80px 20px 20px 20px; */
  box-sizing: boder-box;
  background-color: white;
  /* width: 1186px; */
  /* margin: 0 auto; */
}

.rich-txt-box /deep/ .rich-img {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/myFeedback.vue